import { render } from "./LowCarbonMod.vue?vue&type=template&id=90f2cdda&scoped=true"
import script from "./LowCarbonMod.vue?vue&type=script&lang=js"
export * from "./LowCarbonMod.vue?vue&type=script&lang=js"

import "./LowCarbonMod.vue?vue&type=style&index=0&id=90f2cdda&scoped=true&lang=css"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90f2cdda"]])

export default __exports__